module.exports = __webpack_public_path__ + "img/icon-warning-regn-3.850181ac.svg";